export const LogoMark = ({ className = "h-12 w-12" }) => (
  <span className={`inline-flex shrink-0 items-center justify-center bg-[#f4f0e8] ${className}`}>
    <img src="/logo-mark.png" alt="Vata Infrastructures banyan tree logo" className="h-[92%] w-[92%] object-contain" />
  </span>
);

export const Logo = ({ light }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none">
      <span className={`block font-display text-lg font-extrabold uppercase tracking-wide sm:text-xl ${light ? "text-white" : "text-[var(--ink)]"}`}>
        Vata Infrastructures
      </span>
      <span className={`mt-1 hidden whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.18em] sm:block xl:block lg:hidden ${light ? "text-white/60" : "text-[var(--muted-ink)]"}`}>
        KPWD Class-I Civil Contractor · Bengaluru
      </span>
    </span>
  </span>
);
